import { EPlateCorner } from "../Model/EPlateCorner";

class PlateCornerUtil {
  static toName(plateCorner: EPlateCorner | string) {
    switch (plateCorner) {
      case "Bottom Left (BL)":
      case EPlateCorner.BottomLeft:
        return "Bottom Left (BL)";
      case "Bottom Right (BR)":
      case EPlateCorner.BottomRight:
        return "Bottom Right (BR)";
      case "Top Left (TL)":
      case EPlateCorner.TopLeft:
        return "Top Left (TL)";
      case "Top Right (TR)":
      case EPlateCorner.TopRight:
        return "Top Right (TR)";
      default:
        throw new Error("Unknown plate corner: " + plateCorner);
    }
  }

  static toField(plateCorner: EPlateCorner | string) {
    switch (plateCorner) {
      case "Bottom Left (BL)":
      case EPlateCorner.BottomLeft:
        return EPlateCorner.BottomLeft;
      case "Bottom Right (BR)":
      case EPlateCorner.BottomRight:
        return EPlateCorner.BottomRight;
      case "Top Left (TL)":
      case EPlateCorner.TopLeft:
        return EPlateCorner.TopLeft;
      case "Top Right (TR)":
      case EPlateCorner.TopRight:
        return EPlateCorner.TopRight;
      default:
        throw new Error("Unknown plate corner: " + plateCorner);
    }
  }
}

export default PlateCornerUtil;
